<template>
    <div class="html" ref="htmlRef">
        <!-- 查询条件 -->
        <div class="query" ref="queryRef">
            <a-form layout="inline" :model="data.queryData">
                <a-form-item label="发货单号">
                    <a-input v-model:value="data.queryData.delivery_id" placeholder="" style="width:170px;" allow-clear/>
                </a-form-item>
                <a-form-item label="产品名称">
                    <a-select allow-clear
                        show-search
                        optionFilterProp="label"
                        v-model:value="data.queryData.product_id"
                        :loading="data.isProductType"
                        placeholder=""
                        style="width:170px;"
                    >
                        <a-select-option :value="item.id" v-for="(item,index) in data.productList" :key="index+1" :label="item.name">{{item.name}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item :wrapper-col="{span: 14, offset: 4}">
                    <a-button type="primary" @click="toQueryList(true,data.queryData)">搜索</a-button>
                </a-form-item>
                <a-form-item :wrapper-col="{span: 14, offset: 4}">
                    <a-button @click="resetTable">重置</a-button>
                </a-form-item>
            </a-form>
        </div>
        <!-- 按钮 -->
        <div class="btn" ref="btnRef">
            <a-button class="btn_style" type="primary" ghost v-if="data.btnMenu.remove" @click="deliveryReturnRemove">撤回</a-button>
        </div>
        <!-- 表格 -->
        <div class="table" :style="data.styleTableHeight" ref="tableRef">
                <cTable
                ref="ctableRef"
                :toTableData="data.tableData"
                :toTableY="data.tableHeight"
                :toColumns="columns"
                :toBordered="true"
                toSize="middle"
                :toTableLoading="data.tableLoading"
                toPageStyle="float: right;"
                :toDataTotal="data.dataTotal"
                @tData="tData"
                @setSortedInfo="setSortedInfo"
                @getSelectedRowKeys="getSelectedRowKeys"
                />
        </div>
    </div>
</template>

<script>
import { reactive,ref,computed,onMounted,createVNode,watch,nextTick } from 'vue'
import { useStore } from 'vuex'
import cTable from "@/components/table"
import { getList,remove } from "@/api/delivery/deliveryReturn.js"
import { isOK } from "@/utils/illegal.js"
import { downProduct } from "@/api/down.js"
import { Modal,message } from 'ant-design-vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
export default {
   name: "DeliveryReturn",
   components: { cTable },
   setup(){
       const store = useStore();
        //监听消息栏 是否显示 用于调整表格高度
        watch(
            () => store.state.user.isHeadBar,
            (count, prevCount) => {
                if(count){
                    //表格和翻页区域高度
                    data.styleTableHeight = "height:calc(100% - " + (queryRef.value.offsetHeight + btnRef.value.offsetHeight + 30 ) + "px)";
                    //表格内容滚动高度
                    data.tableHeight = queryRef.value.offsetHeight + btnRef.value.offsetHeight + 46 + 40 + 77 + 62;
                }else{
                    //表格和翻页区域高度
                    data.styleTableHeight = "height:calc(100% - " + (queryRef.value.offsetHeight + btnRef.value.offsetHeight + 30 ) + "px)";
                    //表格内容滚动高度
                    data.tableHeight = queryRef.value.offsetHeight + btnRef.value.offsetHeight + 46 + 40 + 77 + 62 + 60;
                }
            }
        )
        //排序样式数据记录
        const sortedInfo = ref();
        //控件传回的排序样式和值
        const setSortedInfo = (value) =>{
            sortedInfo.value = value;
        }
        const columns = computed(() => {
            const sorted = sortedInfo.value || {};
            return [
                {
                    title: '序号',
                    width: 60,
                    align:"center",
                    customRender: (text) => {
                        return text.index + 1;
                    }
                },
                {
                    title: '发货单号',
                    width: 200,
                    dataIndex: 'deliveryId',
                    key: 'delivery_id',
                    ellipsis: true,
                    slots: {
                        customRender: 'long',
                    },
                },
                {
                    title: '产品名称',
                    width: 200,
                    dataIndex: 'productName',
                    key: 'product_name',
                    ellipsis: true,
                    slots: {
                        customRender: 'long',
                    },
                },
                {
                    title: '出库单',
                    width: 220,
                    dataIndex: 'ioId',
                    key: 'io_id',
                    ellipsis: true,
                    slots: {
                        customRender: 'long',
                    },
                },
                {
                    title: '退回数量',
                    width: 130,
                    dataIndex: 'productNum',
                    key: 'product_num',
                    sorter: true,
                    sortOrder: sorted.columnKey === 'product_num' && sorted.order,
                    sortDirections: ['descend', 'ascend'],
                    ellipsis: true,
                },
                {
                    title: '操作人员',
                    width: 120,
                    dataIndex: 'returnUname',
                    key: 'return_Uname',
                    ellipsis: true,
                    slots: {
                        customRender: 'long',
                    },
                },
                {
                    title: '创建日期',
                    width: 160,
                    sorter: true,
                    sortOrder: sorted.columnKey === 'gmt_create' && sorted.order,
                    sortDirections: ['descend', 'ascend'],
                    dataIndex: 'gmtCreate',
                    key: 'gmt_create',
                    ellipsis: true,
                },
                {
                    title: '更新日期',
                    width: 160,
                    sorter: true,
                    sortOrder: sorted.columnKey === 'gmt_modified' && sorted.order,
                    sortDirections: ['descend', 'ascend'],
                    dataIndex: 'gmtModified',
                    key: 'gmt_modified',
                    ellipsis: true,
                },
                {
                    title: '是否入库',
                    dataIndex: 'inNum',
                    key: 'in_num',
                    ellipsis: true,
                    customRender: (text) => {
                        if(text.record.productNum<=text.record.inNum){
                            return '全部入库';
                        }
                        return text.record.inNum>0?'部分入库':'未入库';
                    }
                },
            ];
        });
        const data = reactive({
            styleTableHeight:"height:calc(100% - 104px)",
            btnMenu: store.state.user.btnList.deliveryReturn,
            queryData:{
                delivery_id:"",
                product_id:"",
            },
            tableLoading: false,
            tableData: [],
            tableHeight: 0,
            selectedRowKeys: [],
            dataTotal:0,
            isProductType:false,
            productList:[],

            //以下是增删改查按钮事件参数 
            modalTitle:"",
            modalType:"",
            isModal: false,
            isModalLoading: false,
            isOkButton: false,
            isCancelButton: false,
            modalData:{
                name:"",
                model:"",
                weight:"",
                size:"",
                color:"",
                unit:"",
                gmt_create:"",
                gmt_modified:"",
                remarks:"",
            },
            modalRules:{
                name:[{ required: true, message: '产品名称不能为空', trigger: 'blur' }],
                model:[{ required: true, message: '产品型号不能为空', trigger: 'blur' }],
                weight:[{ required: true,type:'number', message: '产品重量不能为空', trigger: 'blur' }],
                size:[{ required: true, message: '产品尺寸不能为空', trigger: 'blur' }],
                color:[{ required: true, message: '产品颜色不能为空', trigger: 'blur' }],
                unit:[{ required: true, message: '计量单位不能为空', trigger: 'blur' }],
            },
        })

        //获取表格高度（用于滚轮）
        const tableRef = ref();
        const btnRef = ref();
        const queryRef = ref();
        const htmlRef = ref();
        
        //复选的数据id
        const getSelectedRowKeys = (selectedRowKeys) =>{
            data.selectedRowKeys = selectedRowKeys;
        }

        //调用流程 先跳入table公用控件 然后把数据整体输出回来 再进行查询  state为true时说明是控件的回调
        const ctableRef = ref();
        //跳转到table公用控件 status判断是否是新的搜索
        const toQueryList = (status) =>{
            ctableRef.value.queryList(status,data.queryData);//queryList是cTable子组件里的方法
        }
        const tData = (cont) =>{
            data.tableLoading = true;
            getList({
                page: cont[1].page,
                limit: cont[1].limit,
                delivery_id: isOK(cont[0].delivery_id)?cont[0].delivery_id:"",
                product_id: isOK(cont[0].product_id)?cont[0].product_id:"",
                sort: cont[1].sort,
                desc: cont[1].desc,
            }).then(res =>{
                data.tableLoading = false;
                document.getElementsByClassName('ant-table-body')[0].scrollTop = 0;//搜索后表格回到顶部
                data.tableData = res.data.list;
                data.dataTotal = res.data.total;
            })
        }
        //重置表格数据
        const resetTable = () =>{
            data.queryData.delivery_id = "";
            data.queryData.product_id = "";
            //清空表格复选框选中状态
            ctableRef.value.unSelectedRowKeys();
            toQueryList(true);
        }

        //渲染后 加载数据
        onMounted(() => {
            //加载表格数据
            toQueryList(true);
            //加载产品下拉
            getDownProduct();

            nextTick(()=>{
                //延迟加载
                setTimeout(() =>{
                    if(store.state.user.isHeadBar){
                        //表格和翻页区域高度
                        data.styleTableHeight = "height:calc(100% - " + (queryRef.value.offsetHeight + btnRef.value.offsetHeight + 30 ) + "px)";
                        //表格内容滚动高度
                        data.tableHeight = queryRef.value.offsetHeight + btnRef.value.offsetHeight + 46 + 40 + 77 + 62;
                    }else{
                        //表格和翻页区域高度
                        data.styleTableHeight = "height:calc(100% - " + (queryRef.value.offsetHeight + btnRef.value.offsetHeight + 30 ) + "px)";
                        //表格内容滚动高度
                        data.tableHeight = queryRef.value.offsetHeight + btnRef.value.offsetHeight + 46 + 40 + 77 + 62 + 60;
                    }
                },1);
            })
        });

        //重置modal数据
        const resetModalData = () =>{
            data.modalData = {
                name:"",
                model:"",
                weight:"",
                size:"",
                color:"",
                unit:"",
                gmt_create:"",
                gmt_modified:"",
                remarks:"",
            };
        }

        //获取产品下拉数据
        const getDownProduct = ()=>{
            data.isProductType = true;
            downProduct().then(res =>{
                data.productList = res.data.list;
                data.isProductType = false;
            });
        }

        //按钮-撤回
        const deliveryReturnRemove = ()=>{
            for(let i = 0;i<data.tableData.length;i++){
                if(data.tableData[i].id===data.selectedRowKeys[0]){
                    if(data.tableData[i].qualityNum>0 || data.tableData[i].inNum>0){
                        return message.warning("已进行操作的退货单不可撤回（已质检或已入库视为已操作）");
                    }
                }
            }
            if(data.selectedRowKeys.length==1){
                Modal.confirm({
                    title: '撤回退货单',
                    icon: createVNode(ExclamationCircleOutlined),
                    content: '您是否确定撤回退货单',
                    okText: '确认',
                    cancelText: '取消',
                    //确定
                    onOk() {
                        remove({id:data.selectedRowKeys[0]}).then(res =>{
                            message.success("撤回成功");
                            resetTable();
                        })
                    },
                    // 取消
                    onCancel() {},
                });
            }else if(data.selectedRowKeys.length>1){
                message.warning("不可同时处理多条数据");
            }else{
                message.warning("请选择一条数据");
            }
        }

        return {
            setSortedInfo,
            columns,
            tableRef,
            btnRef,
            queryRef,
            htmlRef,
            ctableRef,
            data,
            getSelectedRowKeys,
            toQueryList,
            tData,
            resetTable,
            resetModalData,

            getDownProduct,
            deliveryReturnRemove,
        }
   }
}
</script>
<style lang='scss' scoped>
.html{
    width: 100%;
    height: 100%;
    background-color: #fff;
    overflow: hidden;
}
.query{
    width: calc(100% - 40px);
    height: auto;
    margin: 10px 20px 0 20px;
}
.btn{
    width: calc(100% - 40px);
    height: auto;
    margin: 10px 20px;
}
.btn_style{
    margin-right: 12px;
}
.table{
    width: calc(100% - 40px);
    // height: calc(100% - 102px);
    margin-left: 20px;
}
</style>